import React from 'react';
import { Link } from 'react-router-dom';
import { FaEllipsisV } from 'react-icons/fa';
import TEST from '../../img/circly-project.png';
import { isFeatureEnabled } from '../../services/feature-flags';
import Tooltip from '../common/Tooltip';

const maxDisplayedTitleLength = 50;

const BoardTile = ({ board }) => {
  const displayedTitle =
    board.title.length > maxDisplayedTitleLength
      ? board.title.slice(0, maxDisplayedTitleLength) + '...'
      : board.title;

  return (
    <li className="project-item">
      <Link to={`/board/${board.id}`} className="project-link">
        <div className="project-circle-wrapper" style={{ position: 'relative' }}>
          {isFeatureEnabled('ALLOW_DELETING_BOARDS') && (
            <div className="board-menu-icon">
              <FaEllipsisV />
            </div>
          )}
          <div
            className="project-circle"
            style={{
              backgroundImage: `url(${TEST})`,
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat'
            }}
          ></div>
        </div>
        <Tooltip title={board.title.length > maxDisplayedTitleLength ? board.title : ''}>
          <div className="project-title">{displayedTitle}</div>
        </Tooltip>
        <div>
          <div className="project-date">
            edited: {`${new Date(board.updatedAt).toLocaleDateString()}`}
          </div>
          {/*<div className="project-privacy" onClick={()=> {this.openUpgradeModal()}}>Public</div>*/}
        </div>
      </Link>
    </li>
  );
};

export default BoardTile;
